var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivityConfig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6s40s9o57a)",
    fill: "#5E6175"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.485 10.975-10.484 6.292-10.486-6.292A1 1 0 0 0 .486 12.69l11 6.6a1 1 0 0 0 1.03 0l11-6.6a1 1 0 1 0-1.028-1.715h-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.485 15.54-10.484 6.292-10.486-6.291a1.002 1.002 0 0 0-1.372.343 1 1 0 0 0 .343 1.372l11 6.6a1 1 0 0 0 1.03 0l11-6.6a1 1 0 0 0-1.028-1.715h-.003zM.485 8.356l9.984 5.991a2.97 2.97 0 0 0 3.062 0l9.984-5.99a1 1 0 0 0 0-1.715L13.53.652a2.973 2.973 0 0 0-3.062 0L.485 6.641a1 1 0 0 0 0 1.714z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "6s40s9o57a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityConfig);
export default __webpack_public_path__ + "static/media/activityConfig.533cb122c03df3d666c9123b06560965.svg";
export { ForwardRef as ReactComponent };